module.exports = __webpack_public_path__ + "img/undraw_teamwork_hpdk.a7b826e1.svg";